export const TILE_STATUS: any = {
    DEFAULT: "DEFAULT",
    CONFIRM_PLACARD_DISPLAY: "ConfirmPlacardDisplay",
    FIRST_PICKUP_DATE_MISSED: "FirstPickupDateMissed",
    READY_FOR_PICKUPS: "ReadyForPickups",
    CANCELLED: 'Cancelled',
    DISPLAYED: 'Displayed'
};

export const PLACARD_STATUS: any = {
    EXPIRED: 'Expired',
    EXPIRED_1: 'Expired 1',
    EXPIRED_2: 'Expired 2',
    CREATED: 'Created',
    CREATED_1: 'Created 1',
    CREATED_2: 'Created 2',
    PENDING: 'Pending',
    ACTIVE: 'Active',
    CANCELLED: 'Cancelled',
    DISPATCHED: 'Dispatched',
    REJECTED: 'Rejected',
    AGED: 'Aged',
    DEFAULT: "DEFAULT",
    PAUSED: 'Inactive'
};

export const CARDS_STATUS: any = {
    CONFIRM_PLACARD_DISPLAY: 'ConfirmPlacardDisplay',
    DISPLAYED: 'Displayed',
    READY_FOR_PICKUPS: 'ReadyForPickups'

};

export const STATUS_BY_TILE: any[] = [
    {
        status: TILE_STATUS.FIRST_PICKUP_DATE_MISSED,
        placards_status: [PLACARD_STATUS.EXPIRED_2,
        PLACARD_STATUS.REJECTED,
        PLACARD_STATUS.AGED]
    },
    {
        status: TILE_STATUS.CONFIRM_PLACARD_DISPLAY,
        placards_status: [
            PLACARD_STATUS.EXPIRED_1,
            PLACARD_STATUS.CREATED_1
        ]
    },
    {
        status: TILE_STATUS.READY_FOR_PICKUPS,
        placards_status: [
            PLACARD_STATUS.DISPATCHED,
            PLACARD_STATUS.PAUSED
        ]
    },
    {
        status: TILE_STATUS.CANCELLED,
        placards_status: [PLACARD_STATUS.CANCELLED]
    },
    {
        status: TILE_STATUS.DISPLAYED,
        placards_status: [
            PLACARD_STATUS.EXPIRED_2,
            PLACARD_STATUS.CREATED_2,
            PLACARD_STATUS.PENDING,
            PLACARD_STATUS.ACTIVE,
            PLACARD_STATUS.REJECTED,
            PLACARD_STATUS.AGED]
    },
    {
        status: TILE_STATUS.DEFAULT,
        placards_status: [PLACARD_STATUS.EXPIRED_1,
        PLACARD_STATUS.EXPIRED_2,
        PLACARD_STATUS.CREATED_1,
        PLACARD_STATUS.CREATED_2,
        PLACARD_STATUS.PENDING,
        PLACARD_STATUS.ACTIVE,
        PLACARD_STATUS.DISPATCHED,
        PLACARD_STATUS.REJECTED,
        PLACARD_STATUS.AGED,
        PLACARD_STATUS.PAUSED
        ]
    }
];

export const MESSAGE_BY_STATUS: any[] = [
    {
        status: TILE_STATUS.READY_FOR_PICKUPS,
        message: 'Ready For Pickups',
        translationKey: 'upplm.summarydashboard.status.readyforpickups'
    },
    {
        status: TILE_STATUS.CONFIRM_PLACARD_DISPLAY,
        message: 'Confirm Placard Display',
        translationKey: 'upplm.common.confirmplacarddisplay'
    },
    {
        status: TILE_STATUS.FIRST_PICKUP_DATE_MISSED,
        message: 'First Pickup Date Missed',
        translationKey: 'upplm.common.firstpickupdatemissed'
    },
    {
        status: TILE_STATUS.DISPLAYED,
        message: 'Displayed',
        translationKey: 'upplm.summarydashboard.status.displayed'
    },
    {
        status: TILE_STATUS.CANCELLED,
        message: 'Cancelled Placards',
        translationKey: 'upplm.common.cancelledplacards'
    },
    {
        status: TILE_STATUS.DEFAULT,
        message: 'Total Placards',
        translationKey: 'upplm.common.totalplacards'
    }
];
